import React from 'react';
import '../styles.css';
import './MyList.css';
import { FiShare2, FiExternalLink, FiTrash2 } from 'react-icons/fi';

export default function MyListScreen({ wishlist, removeProductFromWishlist, sortWishlist }) {
  const total = wishlist.reduce((sum, product) => sum + (Number(product.price) || 0), 0);

  const handleShare = async (item) => {
    const text = `Check out this product: ${item.name} for €${item.price}. See more here: ${item.url}`;

    if (navigator.share) {
      try {
        await navigator.share({ title: 'Check out this product', text, url: item.url });
      } catch (error) {
        // User dismissed the share sheet — not an error, do nothing.
        if (error.name !== 'AbortError') console.error('Failed to share', error);
      }
      return;
    }

    // Fallback for browsers without the Web Share API: copy the link.
    try {
      await navigator.clipboard.writeText(item.url);
      alert('Link copied to clipboard.');
    } catch (error) {
      alert('Sharing is not supported in this browser.');
    }
  };

  const handleOpenInBrowser = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div className="mylist-container">
      <div className="sort-buttons">
        <span className="total-text">Total: €{total.toFixed(2)}</span>
        <button onClick={() => sortWishlist('date')}>Date ↑↓</button>
        <button onClick={() => sortWishlist('price')}>Price ↑↓</button>
      </div>
      <ul className="product-list">
        {wishlist.map((item) => (
          <li key={item.id} className="product">
            <img src={item.imageUrl} alt={item.name} className="product-image" onClick={() => handleOpenInBrowser(item.url)}/>
            <div className="product-info">
              <h2 className="product-name" onClick={() => handleOpenInBrowser(item.url)}>{item.name}</h2>
              <h3 className="product-price">€{Number(item.price) || 0}</h3>
              <div className="icon-row">
                <FiShare2 className="icon" strokeWidth={1.5} onClick={() => handleShare(item)} />
                <FiExternalLink className="icon" strokeWidth={1.5} onClick={() => handleOpenInBrowser(item.url)} />
                <FiTrash2 className="icon trash" strokeWidth={1.5} onClick={() => removeProductFromWishlist(item.id)} />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
